import { ComponentType } from "react";
import { PersonFirstNameFragment } from "gql/graphql";
import { LocalizedName } from "@/shared/data-display/localized-value";
import { Hidable, Value } from "@/shared/value";

/**
 * Имя человека отдельным полем: в анкете части имени показываются по одной, а
 * само имя — локализованное значение и может быть закрыто защитой.
 */
export function PersonFirstName({
  data,
  whenEmpty,
}: {
  data?: Hidable<PersonFirstNameFragment>;
  whenEmpty?: ComponentType;
}) {
  return (
    <Value data={data} whenEmpty={whenEmpty}>
      {(person) => (
        <LocalizedName data={person.firstName} whenEmpty={whenEmpty} />
      )}
    </Value>
  );
}
